// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptId: __t.u64().primaryKey().name("receipt_id"),
  leaseId: __t.u64().name("lease_id"),
  structureId: __t.u64().name("structure_id"),
  unitId: __t.string().name("unit_id"),
  tenant: __t.identity(),
  owner: __t.identity(),
  kind: __t.string(),
  amountSov: __t.i64().name("amount_sov"),
  feeSov: __t.i64().name("fee_sov"),
  detail: __t.string(),
  at: __t.timestamp(),
});
